export { Alignments as TextAlignKinds } from "./Alignments";
